// Split from `components/schedule/TimeSelect.tsx` (rather than co-exported
// there) so that file can stay component-only — non-component exports break
// Fast Refresh, same precedent as `lib/status.ts`/`components/Status.tsx`.
//
// design-system.md's shared `TIME_OPTIONS` — the full 24 hours at 15-minute
// steps (96 entries, `00:00`…`23:45`), not a working-hours subset:
// commission destruction (warehouse.md) isn't bound to booking hours, and no
// Schedule page exists in this package yet to impose its own narrower set.
export const TIME_OPTIONS: string[] = Array.from({ length: 96 }, (_, i) => {
  const hours = String(Math.floor(i / 4)).padStart(2, "0")
  const minutes = String((i % 4) * 15).padStart(2, "0")
  return `${hours}:${minutes}`
})
